import React from 'react';
import useScroll from '@utils/useScroll';
import NavBar from '@components/NavBarFit';
import { TYPE_SWITCH } from '@/schemas/common';
import NavForWorkStation from '../NavForWorkStation';

interface Iprops {
  showShare?: boolean;
  title?: string;
  showNavWorkStation?: boolean;
  showNavOrder?: boolean;
  showNavChannel?: boolean;
  showCouponEnter?: boolean;
  shareComponent?: React.ReactNode;
}

const NavBarScroll = (props: Iprops) => {
  const {
    title = '快手健康',
    showNavWorkStation = false,
    showNavOrder = false,
    showNavChannel = false,
    showShare = false,
    showCouponEnter = false,
    shareComponent = <></>
  } = props;
  const [isScroll] = useScroll();

  return (
    <div className="nav-bar-scroll">
      <NavBar
        title={title}
        type="close"
        theme={isScroll ? 'scroll' : 'transparent'}
        shareComponent={shareComponent}
        showShare={showShare}
      >
        <div
          className={`navbar-btn-container ${
            showNavChannel ? 'nav-btn-start' : ''
          }`}
        >
          {showNavWorkStation && (
            <NavForWorkStation
              type={TYPE_SWITCH.WORKSTATION}
              isScroll={isScroll}
            />
          )}
          <div className="enter-wrapper">
            {/* {showCouponEnter && <CouponEnter />} */}
            {/* {showNavOrder && <AskRecord isScroll={isScroll} />} */}
          </div>

          {showNavChannel && (
            <NavForWorkStation type={TYPE_SWITCH.CHANNEL} isScroll={isScroll} />
          )}
        </div>
      </NavBar>
    </div>
  );
};

export default NavBarScroll;
